import Image from "next/image"
// eslint-disable-next-line import/no-named-as-default
import Balancer from "react-wrap-balancer"

export default function Testimonial(): JSX.Element {
  return (
    <section id="testimonial" aria-label="Testimonial">
      <figure className="mx-auto py-20">
        <blockquote className="mx-auto max-w-5xl text-center text-2xl font-semibold leading-8 text-gray-900 dark:text-gray-50">
          <p>
            <Balancer>
              “Thanks to this robust creative solution, our organization has streamlined
              creative operations processes, leading to increased efficiency and
              performance in our creative content.”
            </Balancer>
          </p>
        </blockquote>
        <figcaption className="mt-10 flex items-center justify-center gap-x-5">
          <Image
            className="h-11 w-11 rounded-full object-cover shadow-lg shadow-indigo-500/50 ring-2 ring-white dark:ring-gray-700"
            src="/images/kassik.jpeg"
            alt="Image of Kassidi Koronkowski"
            width={44}
            height={44}
          />
          <div>
            <p className="font-semibold text-gray-900 dark:text-gray-50">Kassidi Koronkowski</p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Director of Marketing
            </p>
          </div>
        </figcaption>
      </figure>
    </section>
  )
}
